import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CommonModal from '../../CommonComponents/CommonModal';
import CommonSelect from '../../CommonComponents/CommonSelect';
import { getAllDashUsers } from '../../redux/actions/dashusers';
import { showUserForm, assignProduct } from '../../redux/actions/common';

const Assignment = ({
  getUsers, users, title, showForm, clientName, product, productAssignment,
}) => {
  const [user, handleChange] = useState(null);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const assign = () => {
    if (user) {
      const data = {
        dashUserId: user,
        brands: [product.id],
      }
      productAssignment(data)
    }
  }

  return (
    <CommonModal
      title={title}
      width="xl"
      open
      onYes={assign}
      onClose={() => showForm(0)}
      successButtonText="Assign"
      cancelButtonText="Cancel"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <div className="row">
        <div className="col-6">
          Client:
          {' '}
          {clientName}
        </div>
        <div className="col-6">
          Product:
          {' '}
          {product.productName}
        </div>
      </div>
      <br />
      <CommonSelect label="Managers" options={users} handleChange={handleChange} />
    </CommonModal>
  );
}

const mapState = (state) => ({
  users: state.dashusers.users,
  visibleForm: state.common.showUserForm,
});

const mapActions = {
  getUsers: getAllDashUsers,
  showForm: showUserForm,
  productAssignment: assignProduct,
};

export default connect(mapState, mapActions)(Assignment);
